import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  defaultTitle: {
    description: 'Service Level Dropdown default title',
    defaultMessage: 'Select Service Level',
    id: 'xX9xdv',
  },
});
